import Route from '@core/components/Route';
import Grid2 from '@shared/components/Grid2';
import { H3 } from '@shared/components/Heading';
import List from '@shared/components/List';
import ListItem from '@shared/components/ListItem';
import Paragraph from '@shared/components/Paragraph';
import { FC, memo } from 'react';

import { FALKO_ZANDER_ARTS } from '../../assets/data/falko-zander-arts';
import { FALKO_ZANDER_MASTERS } from '../../assets/data/falko-zander-masters';
import { FALKO_ZANDER_MILESTONES } from '../../assets/data/falko-zander-milestones';
import { H2Gold } from '../../components/ColoredHeading';
import { SectionDark3 } from '../../components/ColoredSection';
import GenericLayout from '../../components/GenericLayout';
import PageImage from '../../components/PageImage';
import { PageImageId } from '../../types/page-image';

const FalkoZander: FC = () => (
  <GenericLayout title='Falko Zander'>
    <PageImage id={PageImageId.FalkoZander} />

    <SectionDark3>
      <H2Gold center margin={{ bottom: '2rem' }}>
        Gemeinsam auf dem Weg zur besten Version
      </H2Gold>

      <Grid2 spacing='2rem'>
        <Grid2.Item>
          <H3>Kampfkunst Lebenslauf</H3>
          <List bullets itemProps={{ margin: { y: '0.5rem' } }} margin={{ y: '0.75em' }}>
            {FALKO_ZANDER_MILESTONES.map((text, index) => (
              <ListItem key={index}>{text}</ListItem>
            ))}
          </List>
        </Grid2.Item>
        <Grid2.Item>
          <H3>Wichtige Lehrer</H3>
          <Paragraph>
            Falko Zander war und ist Freund und Schüler mehrerer herausragender (Groß-)Meister:
          </Paragraph>
          <List bullets itemProps={{ margin: { y: '0.5rem' } }} margin={{ y: '0.75em' }}>
            {FALKO_ZANDER_MASTERS.map((element, index) => (
              <ListItem key={index}>{element}</ListItem>
            ))}
          </List>

          <H3 margin={{ top: '2rem' }}>Mehr zu den Kampfkünsten</H3>
          <List bullets itemProps={{ margin: { y: '0.5rem' } }} margin={{ y: '0.75em' }}>
            {FALKO_ZANDER_ARTS.map(({ href, text }) => (
              <ListItem key={href}>
                <Route href={href}>{text}</Route>
              </ListItem>
            ))}
          </List>
        </Grid2.Item>
      </Grid2>
    </SectionDark3>
  </GenericLayout>
);

export default memo(FalkoZander);
